function Address() {
  return (
    <div className="xl:w-2/4 flex flex-col items-center font-extralight text-custom_pink pt-16 text-center sm:w-full">
      <img src="pg-flygl.png" className="w-80 h-80" alt="flygl" />
      <div>
        <h3 className="text-black font-normal text-2xl">امیر حسین سیفی</h3>
        <p className="mb-5">برنامه نویس و طراح</p>
      </div>
      <div dir="ltr">
        <p>
          <i className="bx bxs-phone text-black"></i> +98 901 949 9640
        </p>
        <p>
          <i className="bx bxs-user text-black"></i> Mch AT siteamirhossein-259bc-5c006.web.app
        </p>
      </div>
    </div>
  );
}

export default Address;